import { TeamClientModel } from '@sport1/types/sportData'

const canOpenTeam = (team?: TeamClientModel): boolean => {
    return !!team?.code || !!team?.nationality || !!team?.country
}

export default canOpenTeam
